import React from "react";
import type { SystemMessageResponseDto } from "@semo/api-contracts";
import { ChatBubble } from "@semo/shared-ui";

interface SystemMessageProps {
  message: SystemMessageResponseDto;
}

export const SystemMessage: React.FC<SystemMessageProps> = ({ message }) => {
  return (
    <div className="flex justify-center py-2">
      <ChatBubble variant="system">
        {message.message ?? "시스템 메시지"}
      </ChatBubble>
    </div>
  );
};
